module.exports = __webpack_public_path__ + "static/scale-model-of-executive-travel-in-lincoln-nebraska-695e99b4a6e3160d443534286d09b017.png";